/*
 * i18n del manager NeoFlux — pattern "gettext": la CHIAVE è la stringa italiana.
 * L'italiano è la lingua di default (nessun dizionario, la chiave è già IT).
 * Per le altre lingue si cerca la traduzione; se manca, si ricade sull'italiano.
 *
 * I dizionari EN esistenti (i18n/pages/*.en.js) vengono uniti in un unico
 * dizionario. ES/FR/DE partono da un nucleo comune (bottoni, navigazione, azioni)
 * ed è possibile ampliarli con lo stesso schema chiave-italiana → traduzione.
 */
import accountEn from './pages/account.en.js';
import addcardEn from './pages/addcard.en.js';
import cloudEn from './pages/cloud.en.js';
import comingsoonEn from './pages/comingsoon.en.js';
import contabilitaEn from './pages/contabilita.en.js';
import homeEn from './pages/home.en.js';
import hostingEn from './pages/hosting.en.js';
import settingsPecEn from './pages/settings-support-pec.en.js';
import { en as sviluppatoreEn, es as sviluppatoreEs, fr as sviluppatoreFr, de as sviluppatoreDe } from './pages/sviluppatore.js';

const EN = {
  ...homeEn, ...accountEn, ...contabilitaEn, ...cloudEn,
  ...hostingEn, ...addcardEn, ...comingsoonEn, ...settingsPecEn,
  ...sviluppatoreEn,
};

// Nucleo comune tradotto a mano (le chiavi mancanti ricadono sull'italiano).
const CORE = {
  es: {
    'Chiudi': 'Cerrar', 'Annullare': 'Cancelar', 'Avanti': 'Siguiente', 'Indietro': 'Atrás',
    'Registrare': 'Guardar', 'Salva': 'Guardar', 'Convalidare': 'Validar', 'Modificare': 'Editar',
    'Modifica': 'Editar', 'Gestire': 'Gestionar', 'Aggiungi': 'Añadir', 'Elimina': 'Eliminar',
    'Eliminare': 'Eliminar', 'Crea': 'Crear', 'Cerca': 'Buscar', 'Ricerca': 'Buscar', 'Home': 'Inicio',
    'Il mio profilo': 'Mi perfil', 'Parametri': 'Parámetros', 'Impostazioni': 'Ajustes',
    'Contabilità': 'Contabilidad', 'Utenti e profilo': 'Usuarios y perfil', 'Supporto': 'Soporte',
    'Pagina iniziale': 'Inicio', 'Lingua': 'Idioma', 'Sicurezza': 'Seguridad',
    'La tua organizzazione': 'Tu organización', 'Gestione dei prodotti': 'Gestión de productos',
    'Etichetta': 'Etiqueta', 'Condizioni generali': 'Condiciones generales',
    'Documenti e Contratti speciali': 'Documentos y contratos especiales', 'Da pagare': 'Por pagar',
    'Token API': 'Tokens API', 'Sì, elimina': 'Sí, eliminar', 'Nessun risultato': 'Sin resultados',
  },
  fr: {
    'Chiudi': 'Fermer', 'Annullare': 'Annuler', 'Avanti': 'Suivant', 'Indietro': 'Retour',
    'Registrare': 'Enregistrer', 'Salva': 'Enregistrer', 'Convalidare': 'Valider', 'Modificare': 'Modifier',
    'Modifica': 'Modifier', 'Gestire': 'Gérer', 'Aggiungi': 'Ajouter', 'Elimina': 'Supprimer',
    'Eliminare': 'Supprimer', 'Crea': 'Créer', 'Cerca': 'Rechercher', 'Ricerca': 'Recherche', 'Home': 'Accueil',
    'Il mio profilo': 'Mon profil', 'Parametri': 'Paramètres', 'Impostazioni': 'Paramètres',
    'Contabilità': 'Comptabilité', 'Utenti e profilo': 'Utilisateurs et profil', 'Supporto': 'Assistance',
    'Pagina iniziale': 'Accueil', 'Lingua': 'Langue', 'Sicurezza': 'Sécurité',
    'La tua organizzazione': 'Votre organisation', 'Gestione dei prodotti': 'Gestion des produits',
    'Etichetta': 'Étiquette', 'Condizioni generali': 'Conditions générales',
    'Documenti e Contratti speciali': 'Documents et contrats spéciaux', 'Da pagare': 'À payer',
    'Token API': 'Jetons API', 'Sì, elimina': 'Oui, supprimer', 'Nessun risultato': 'Aucun résultat',
  },
  de: {
    'Chiudi': 'Schließen', 'Annullare': 'Abbrechen', 'Avanti': 'Weiter', 'Indietro': 'Zurück',
    'Registrare': 'Speichern', 'Salva': 'Speichern', 'Convalidare': 'Bestätigen', 'Modificare': 'Bearbeiten',
    'Modifica': 'Bearbeiten', 'Gestire': 'Verwalten', 'Aggiungi': 'Hinzufügen', 'Elimina': 'Löschen',
    'Eliminare': 'Löschen', 'Crea': 'Erstellen', 'Cerca': 'Suchen', 'Ricerca': 'Suche', 'Home': 'Startseite',
    'Il mio profilo': 'Mein Profil', 'Parametri': 'Parameter', 'Impostazioni': 'Einstellungen',
    'Contabilità': 'Buchhaltung', 'Utenti e profilo': 'Benutzer und Profil', 'Supporto': 'Support',
    'Pagina iniziale': 'Startseite', 'Lingua': 'Sprache', 'Sicurezza': 'Sicherheit',
    'La tua organizzazione': 'Ihre Organisation', 'Gestione dei prodotti': 'Produktverwaltung',
    'Etichetta': 'Etikett', 'Condizioni generali': 'Allgemeine Geschäftsbedingungen',
    'Documenti e Contratti speciali': 'Dokumente und Sonderverträge', 'Da pagare': 'Zu zahlen',
    'Token API': 'API-Token', 'Sì, elimina': 'Ja, löschen', 'Nessun risultato': 'Keine Ergebnisse',
  },
};

// Fallback: le chiavi non tradotte ricadono sull'ITALIANO (la chiave stessa).
const DICTS = {
  en: EN,
  es: { ...CORE.es, ...sviluppatoreEs },
  fr: { ...CORE.fr, ...sviluppatoreFr },
  de: { ...CORE.de, ...sviluppatoreDe },
};

export const LOCALES = ['it', 'en', 'es', 'fr', 'de'];
export const LOCALE_LABELS = { it: 'Italiano', en: 'English', es: 'Español', fr: 'Français', de: 'Deutsch' };

export function translate(locale, key, vars) {
  let s = key;
  if (locale && locale !== 'it' && DICTS[locale] && DICTS[locale][key] != null) s = DICTS[locale][key];
  if (vars) Object.keys(vars).forEach((k) => { s = String(s).replace(new RegExp(`\\{${k}\\}`, 'g'), vars[k]); });
  return s;
}
